exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".reset-file-button[data-v-ed540f2e]{height:35px}.status-area[data-v-ed540f2e]{text-align:right;overflow:hidden;word-break:break-all}.status-area.status-area-in-modal[data-v-ed540f2e]{text-align:center}.cancel-button-area[data-v-ed540f2e]{margin-top:15px;text-align:center}", ""]);

